import cx from "classnames";
import { useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { ToastTypes, withToast } from "../../contexts/toastr.context";
import { Community } from "../../types/community/community.type";
import { User } from "../../types/user/minimal-user.type";
import { Button, TextInput } from "../../_components";
import {
  ActionModal,
  ActionModelTrigger,
} from "../../_components/action-modal.component";
import OtpBox from "../../_components/atoms/otp-box.component";
import constants from "../../_config/constants.config";
import continents from "../../_config/country-codes.config.json";
import { mixPanel } from "../../_config/mixpanel.config";
import { UserService } from "../../_service";
import { VerificationService } from "../../_service/verification.service";
import { createSession } from "../../_store/_actions/auth.actions";
import { setCommunity } from "../../_store/_actions/community.actions";

export const ACCOUNT_VERIFICATION_PAGE_ROUTE = "/settings/verification";

interface Props {
  user: User;
  setUser: (user: any) => void;
  community: Community;
  updateCommunity: (community: any) => void;
  addToast: any;
  popup?: boolean;
}
function AccountVerificationPageComponent({
  user,
  setUser,
  community,
  updateCommunity,
  addToast,
  popup = false,
}: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const onUnlink = (unlinkType: string, callback = (e?: any) => {}) => {
    setIsLoading(true);
    UserService.unlinkEmailOrMobile(unlinkType)
      .then((res) => {
        addToast(res.message, "", ToastTypes.success);
        setUser({
          ...user,
          [unlinkType]: null,
        });
      })
      .catch((err) => {
        console.log({ err });
        addToast(
          "Something went wrong while unlinking!",
          "",
          ToastTypes.danger
        );
      })
      .finally(() => {
        setIsLoading(false);
        callback();
      });
  };

  return (
    <div className="UserWallPage Card rounded shadow theme-bg-surface">
      {/* headers */}
      <div className="theme-bg-surface pl-4 pr-2 py-4 rounded-t border-b theme-border-default flex items-center justify-between">
        <span className="font-bold theme-text-heading-2">
          Account Verification
        </span>
        {/* <div className="theme-text-subtitle-1">ID: {community.id}</div> */}
      </div>
      <div className="card p-5 pt-0 theme-text-heading-2 mt-2 ">
        {/* email part */}
        <EmailVerification
          user={user}
          setUser={setUser}
          popup={popup}
          onUnlink={onUnlink}
          isLoading={isLoading}
        />
        {/* mobile part */}
        <MobileVerification
          user={user}
          setUser={setUser}
          popup={popup}
          onUnlink={onUnlink}
          isLoading={isLoading}
          className="theme-bg-surface"
          community={community}
        />
      </div>
    </div>
  );
}

interface EmailVerificationProps {
  user: User;
  setUser?: (user: User) => void;
  popup?: boolean;
  className?: string;
  onUnlink?: (unlinkType: string, callback: (e?: any) => void) => void;
  isLoading?: boolean;
}

function EmailVerification({
  user,
  setUser = (e) => {},
  popup = false,
  className = "",
  onUnlink = (e) => {},
  isLoading = false,
}: EmailVerificationProps) {
  const [email, setEmail] = useState<any>(user.email ?? ""); // to save email
  const [isEmailSubmitable, setIsEmailSubmitable] = useState(
    user.email ? true : false
  );
  const [isOTPSent, setIsOTPSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpVerifyError, setOtpVerifyError] = useState("");
  const [otpSendError, setOtpSendError] = useState("");

  const [prevUser, setPrevUser] = useState<any>(null);

  const [reverificationInProgress, setReverificationInProgress] =
    useState(false);

  const cancelReverification = () => {
    setReverificationInProgress(false);
    setEmail(user.email);
  };

  const checkForExistingEmail = () => {
    setLoading(true);
    setOtpSendError("");
    VerificationService.checkForEmailExisting(email).then((response) => {
      if (response.prevUser) {
        setLoading(false);
        // alert
        setPrevUser(response.prevUser);
      } else {
        sendOTPToMail();
      }
    });
  };

  const sendOTPToMail = () => {
    setLoading(true);
    setOtpSendError("");
    setPrevUser(null);
    UserService.verifyEmailSendOTP(user, email)
      .then(({ message }) => {
        setLoading(false);
        setIsOTPSent(true);
      })
      .catch((error) => {
        setLoading(false);
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          setOtpSendError(error.response.data.message);
        } else {
          setOtpSendError("Something went wrong!");
        }
        console.log({ error });
      });
  };

  const verifyOTPMail = (otp: string) => {
    setLoading(true);
    setOtpVerifyError("");
    UserService.verifyEmailVerifyOTP(user, email, otp)
      .then(({ message }) => {
        setLoading(false);
        setIsOTPSent(false);
        setUser({ ...user, email });
        setReverificationInProgress(false);
      })
      .catch((error) => {
        setLoading(false);
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          setOtpVerifyError(error.response.data.message);
        } else {
          setOtpVerifyError("Something went wrong!");
        }
        console.log({ error });
      });
  };

  return (
    <div className={`mb-4  ${className}`}>
      <div className="mb-1 font-bold">Email</div>
      <TextInput
        placeholder="Email"
        defaultValue={email}
        onChange={(value) => {
          setEmail(value);
        }}
        readOnly={
          (!reverificationInProgress && user.email) || isOTPSent ? true : false
        }
        validator={(value) => {
          if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
            setIsEmailSubmitable(false);
            return "Email is not valid!";
          } else {
            setIsEmailSubmitable(true);
          }
        }}
        // @ts-ignore
        postfix={
          reverificationInProgress ? (
            ""
          ) : user.email ? (
            <span className="px-4 text-xs text-green-500">Verified</span>
          ) : (
            <span className="px-4 text-xs text-red-500">Unverified</span>
          )
        }
      />
      {user.email && user.mobile ? (
        !reverificationInProgress ? (
          <>
            <span
              className="text-xs text-green-500 cursor-pointer mr-2"
              onClick={(e) => {
                setReverificationInProgress(true);
              }}>
              Change
            </span>
            <ActionModelTrigger
              header="Are you sure you want to unlink your email?"
              onSubmit={(closePrompt) => {
                onUnlink("email", closePrompt);
              }}
              isLoading={isLoading}
              component={
                <span className="text-xs text-red-500 cursor-pointer">
                  Unlink
                </span>
              }
              children={undefined}
            />
          </>
        ) : (
          <></>
        )
      ) : null}
      {/* verify email button */}
      {!isOTPSent ? (
        <>
          <div className="w-full flex items-center">
            {user.email && !reverificationInProgress ? (
              <></>
            ) : (
              <>
                <Button
                  label="Request OTP"
                  disabled={!isEmailSubmitable}
                  onClick={checkForExistingEmail}
                  isLoading={loading}
                />
                {reverificationInProgress ? (
                  <span
                    className="text-xs text-red-500 cursor-pointer ml-2"
                    onClick={(e) => {
                      cancelReverification();
                    }}>
                    {" "}
                    Cancel
                  </span>
                ) : (
                  <></>
                )}
              </>
            )}
          </div>
          {otpSendError ? (
            <div className="theme-text-danger text-xs mt-2">{otpSendError}</div>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          <div>Enter the magic code sent on {email}</div>
          <OtpBox
            className={popup ? "w-full" : "w-1/2"}
            onVerify={verifyOTPMail}
            onCancel={() => {
              setIsOTPSent(false);
            }}
          />
          {otpVerifyError ? (
            <div className="theme-text-danger text-xs mt-2">
              {otpVerifyError}
            </div>
          ) : (
            <></>
          )}
        </>
      )}
      <ActionModal
        active={prevUser}
        setActive={setPrevUser}
        header="Looks like somebody is already using it"
        buttons={[
          {
            label: "Cancel",
            isFlat: true,
            onClick: () => {
              setPrevUser(null);
            },
          },
          {
            label: "Switch Account",
            onClick: () => {
              // clear the session
              localStorage.removeItem("pensil.user");
              mixPanel.reset();
              window.location.href = "/";
            },
          },
          {
            label: "Send OTP",
            onClick: () => {
              sendOTPToMail();
            },
          },
        ]}
        onSubmit={undefined}
        title={undefined}
        isLoading={undefined}
        btnColor={undefined}>
        <div className="flex items-center flex-col">
          <img
            src={prevUser?.picture}
            width="64px"
            className="mb-2"
            alt="profile pic"
          />
          <div>Name: {prevUser?.name}</div>
        </div>
      </ActionModal>
    </div>
  );
}

interface MobileVerificationProps {
  user: User;
  setUser?: (e: any) => void;
  popup?: boolean;
  className?: string;
  onUnlink?: any;
  isLoading?: boolean;
  community?: Community;
}

function MobileVerification({
  user,
  setUser = (e) => {},
  popup = false,
  className = "",
  onUnlink,
  isLoading = false,
  community,
}: MobileVerificationProps) {
  const [countryCode, setCountryCode] = useState(
    community
      ? community.configurables[constants.COMMUNITY_DEFAULT_COUNTRY_CODE]
      : "+91"
  );
  const [mobile, setMobile] = useState<any>(user.mobile ?? ""); // to save email
  const [isMobileSubmitable, setIsMobileSubmitable] = useState(
    user.mobile ? true : false
  );
  const [isOTPSent, setIsOTPSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpVerifyError, setOtpVerifyError] = useState("");
  const [otpSendError, setOtpSendError] = useState("");

  const [prevUser, setPrevUser] = useState<any>(null);

  const [reverificationInProgress, setReverificationInProgress] =
    useState(false);

  const cancelReverification = () => {
    setReverificationInProgress(false);
    setMobile(user.mobile);
  };

  const checkForExistingMobile = () => {
    setLoading(true);
    setOtpSendError("");
    VerificationService.checkForMobileExisting(mobile).then((response) => {
      if (response.prevUser) {
        setLoading(false);
        // alert
        setPrevUser(response.prevUser);
      } else {
        sendOTPToMobile();
      }
    });
  };

  const sendOTPToMobile = () => {
    setLoading(true);
    setOtpSendError("");
    setPrevUser(null);
    UserService.verifyMobileSendOTP(user, countryCode, mobile)
      .then(({ message }) => {
        setLoading(false);
        setIsOTPSent(true);
      })
      .catch((error) => {
        setLoading(false);
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          setOtpSendError(error.response.data.message);
        } else {
          setOtpSendError("Something went wrong!");
        }
        console.log({ error });
      });
  };

  const verifyOTPMobile = (otp: string) => {
    setLoading(true);
    setOtpVerifyError("");
    UserService.verifyMobileVerifyOTP(user, mobile, otp)
      .then(({ message }) => {
        setLoading(false);
        setIsOTPSent(false);
        setUser({ ...user, mobile });
        setReverificationInProgress(false);
      })
      .catch((error) => {
        setLoading(false);
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          setOtpVerifyError(error.response.data.message);
        } else {
          setOtpVerifyError("Something went wrong!");
        }
        console.log({ error });
      });
  };

  return (
    <div className={`mb-4  ${className}`}>
      <div className="mb-1 font-bold">Mobile</div>
      <div className="flex items-center">
        <div
          className={cx("cursor-pointer mr-2 rounded", {
            "border theme-border-default": user.mobile,
          })}>
          <Select
            isDisabled={!reverificationInProgress && user.mobile ? true : false}
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
            }}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: "var(--theme-divider-color)",
                color: "var(--theme-default-text-color)",
                backgroundColor: "var(--theme-bg-surface)",
                cursor: "pointer",
              }),
              menu: (baseStyles, state) => ({
                ...baseStyles,
                color: "var(--theme-heading-2-text-color)",
              }),
              menuList: (baseStyles, state) => ({
                ...baseStyles,
                backgroundColor: "var(--theme-surface-color)",
                borderColor: "var(--theme-divider-color)",
              }),
              option: (baseStyles, state) => ({
                ...baseStyles,
                backgroundColor: state.isSelected
                  ? "var(--theme-bg-primary)"
                  : "var(--theme-surface-color)",
                cursor: "pointer",
                color: "var(--theme-text-heading-2)",
                ":hover": {
                  backgroundColor: "var(--theme-background-color)",
                  color: "var(--theme-heading-1-text-color)",
                },
              }),
            }}
            className="select theme-border-default theme-bg-surface  theme-text-default rounded cursor-pointer w-32 theme-bg-primary"
            placeholder={countryCode}
            value={countryCode}
            onChange={(value) => {
              setCountryCode(value.value);
            }}
            name="color"
            options={continents}
          />
        </div>
        <TextInput
          inputPattern={/^\d{0,15}$/}
          placeholder="Enter Mobile No."
          validator={(value) => {
            if (!/^\d{0,15}$/.test(value)) {
              setIsMobileSubmitable(false);
              return "Mobile number is not valid!";
            } else {
              setIsMobileSubmitable(true);
            }
          }}
          defaultValue={mobile}
          onChange={(value) => {
            setMobile(value);
          }}
          className="py-2"
          containerClassName="w-full"
          readOnly={
            (!reverificationInProgress && user.mobile) || isOTPSent
              ? true
              : false
          }
          //@ts-ignore
          postfix={
            reverificationInProgress ? (
              ""
            ) : user.mobile ? (
              <span className="px-4 text-xs text-green-500">Verified</span>
            ) : (
              <span className="px-4 text-xs text-red-500">Unverified</span>
            )
          }
        />
      </div>
      {user.email && user.mobile ? (
        !reverificationInProgress ? (
          <>
            <span
              className="text-xs text-green-500 cursor-pointer mr-2"
              onClick={(e) => {
                setReverificationInProgress(true);
              }}>
              Change
            </span>
            <ActionModelTrigger
              header="Are you sure you want to unlink your mobile?"
              component={
                <span className="text-xs text-red-500 cursor-pointer">
                  Unlink
                </span>
              }
              onSubmit={(closePrompt: string) => {
                onUnlink("mobile", closePrompt);
              }}
              isLoading={isLoading}
              children={undefined}
            />
          </>
        ) : (
          <></>
        )
      ) : null}
      {/* verify email button */}
      {!isOTPSent ? (
        <>
          <div className="w-full flex items-center">
            {user.mobile && !reverificationInProgress ? (
              <></>
            ) : (
              <>
                <Button
                  label="Request OTP"
                  disabled={!isMobileSubmitable}
                  onClick={checkForExistingMobile}
                  isLoading={loading}
                />
                {reverificationInProgress ? (
                  <span
                    className="text-xs text-red-500 cursor-pointer ml-2"
                    onClick={(e) => {
                      cancelReverification();
                    }}>
                    {" "}
                    Cancel
                  </span>
                ) : (
                  <></>
                )}
              </>
            )}
          </div>
          {otpSendError ? (
            <div className="theme-text-danger text-xs mt-2">{otpSendError}</div>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          <div>Enter the magic code sent on {mobile}</div>
          <OtpBox
            className={popup ? "w-full" : "w-1/2"}
            onVerify={verifyOTPMobile}
            onCancel={() => {
              setIsOTPSent(false);
            }}
          />
          {otpVerifyError ? (
            <div className="theme-text-danger text-xs mt-2">
              {otpVerifyError}
            </div>
          ) : (
            <></>
          )}
        </>
      )}
      <ActionModal
        active={prevUser}
        setActive={setPrevUser}
        header="Looks like somebody is already using it"
        buttons={[
          {
            label: "Cancel",
            isFlat: true,
            onClick: () => {
              setPrevUser(null);
            },
          },
          {
            label: "Switch Account",
            onClick: () => {
              // clear the session
              localStorage.removeItem("pensil.user");
              mixPanel.reset();
              window.location.href = "/";
            },
          },
          {
            label: "Send OTP",
            onClick: () => {
              sendOTPToMobile();
            },
          },
        ]}
        onSubmit={undefined}
        title={undefined}
        isLoading={undefined}
        btnColor={undefined}>
        <div className="flex items-center flex-col">
          <img
            src={prevUser?.picture}
            width="64px"
            className="mb-2"
            alt="profile pic"
          />
          <div>Name: {prevUser?.name}</div>
        </div>
      </ActionModal>
    </div>
  );
}

const AccountVerificationPage = withToast(
  connect(
    (s: any) => ({
      user: s.auth,
      community: s.community,
    }),
    (d: any) =>
      bindActionCreators(
        {
          updateCommunity: setCommunity,
          setUser: createSession,
        },
        d
      )
  )(AccountVerificationPageComponent)
);
export default AccountVerificationPage;
export { MobileVerification, EmailVerification };
